var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "class-page",
      staticStyle: { padding: "15px" },
      attrs: { id: "classPage" }
    },
    [
      _c("class-page-header", {
        attrs: {
          details: _vm.details,
          "current-section": _vm.section,
          course: _vm.course,
          menu: _vm.menu,
          "course-content": _vm.courseContent
        }
      }),
      _vm._v(" "),
      _vm.grades.length
        ? _c("div", { staticClass: "grades" }, [
            _c(
              "h2",
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.classPage.index.classPage_currentGrades"
                      )
                    ) +
                    "\n\t\t\t"
                ),
                _c("font-awesome-icon", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip.top-center",
                      value: {
                        content: _vm.gradesFootNote,
                        trigger: "hover click"
                      },
                      expression:
                        "{content: gradesFootNote, trigger: 'hover click'}",
                      modifiers: { "top-center": true }
                    }
                  ],
                  attrs: {
                    icon: "question-circle",
                    size: "lg",
                    "fixed-width": ""
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.grades, function(grade) {
                return _c("li", { key: grade.MP_CODE }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.goToGradesBreakdown(grade.MP_CODE)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(grade.MP_CODE) + "\n\t\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [_vm._v(":")]),
                  _vm._v(" " + _vm._s(grade.GRADE) + "\n\t\t\t\t"),
                  _c("br"),
                  _vm._v(" "),
                  grade.GRADE_COMPLETED_FLG === "Y"
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: {
                                content: _vm.gradesFootNote,
                                trigger: "hover click"
                              },
                              expression:
                                "{content: gradesFootNote, trigger: 'hover click'}",
                              modifiers: { "top-center": true }
                            }
                          ]
                        },
                        [_vm._v("\n\t\t\t\t\t**\n\t\t\t\t")]
                      )
                    : _c("span", [_vm._v(_vm._s(grade.LAST_CALCULATED_DATE))])
                ])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.assignments.length > 0
        ? _c(
            "div",
            { staticClass: "class-assignments" },
            [
              _c("h2", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "MAIN_CONTENT.commonContent.classPage_upcomingAssignments"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c(
                "span",
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.commonContent.classPage_upcomingAssignmentTotal",
                          { count: _vm.assignments.length }
                        )
                      ) +
                      "\n\t\t\t"
                  ),
                  _vm.dueSoon.length ? [_vm._v(" | ")] : _vm._e(),
                  _vm._v(" "),
                  _vm.dueSoon.length
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top-center",
                              value: {
                                content: _vm.$t(
                                  "commonText.dueSoonTextDescription"
                                ),
                                trigger: "hover click"
                              },
                              expression:
                                "{content: $t('commonText.dueSoonTextDescription'), trigger: 'hover click'}",
                              modifiers: { "top-center": true }
                            }
                          ],
                          staticClass: "text-danger"
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.AssignmentsCarousel.classPage_dueSoon",
                                  { count: _vm.dueSoon.length }
                                )
                              ) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "view-options" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-transparent",
                    class: { active: _vm.assignmentsView === "slider" },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.setAssignmentsView("slider")
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-columns",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.classPage.index.classPage_sliderView"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-transparent",
                    class: { active: _vm.assignmentsView === "grid" },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.setAssignmentsView("grid")
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-th",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.classPage.index.classPage_gridView"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-transparent",
                    class: { active: _vm.assignmentsView === "list" },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.setAssignmentsView("list")
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-th-list",
                      attrs: { "aria-hidden": "true" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.classPage.index.classPage_listView"
                          )
                        )
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.assignments.length && _vm.assignmentsView === "slider"
                ? _c("assignments-carousel", {
                    attrs: {
                      "carousel-class":
                        "assignments-carousel color-status " +
                        _vm.getDisplayStyle,
                      "carousel-data": _vm.assignments,
                      "carousel-id": "ac-cwp-01",
                      "color-variant": "blank",
                      margin: 10,
                      "show-nav": true,
                      "show-course": false
                    }
                  })
                : _vm.assignments.length && _vm.assignmentsView === "grid"
                ? _c("assignments-grid", {
                    attrs: {
                      "grid-class": "assignments-grid color-status",
                      "grid-data": _vm.assignments,
                      "grid-id": "ag-cwp-01",
                      "show-course": false
                    }
                  })
                : _vm.assignments.length && _vm.assignmentsView === "list"
                ? _c("assignments-list", {
                    attrs: {
                      "list-class": "assignments-list color-status",
                      "list-data": _vm.assignments,
                      "list-id": "al-cwp-01",
                      "show-course": false
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.studentReports.length > 0 || _vm.groupReports.length > 0
        ? _c(
            "panel-basic",
            {
              attrs: {
                title:
                  "" +
                  _vm.$t(
                    "MAIN_CONTENT.classPage.index.classPage_reportsForStudent",
                    { student: _vm.selectedStudent.FIRST_NAME }
                  ),
                id: "reports",
                collapsable: true
              }
            },
            [
              _c("template", { slot: "title" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.classPage.index.classPage_reportsForStudent",
                        { student: _vm.selectedStudent.FIRST_NAME }
                      )
                    ) +
                    "\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c("class-items", {
                attrs: { "items-data": _vm.studentReports, "folder-type": "S" }
              }),
              _vm._v(" "),
              _vm._l(_vm.groupReports, function(group) {
                return [
                  _c(
                    "div",
                    { key: group.FOLDER_ID },
                    [
                      _c("h3", { staticClass: "class-items-heading" }, [
                        _vm._v(_vm._s(group.FOLDER_NAME))
                      ]),
                      _vm._v(" "),
                      _c("class-items", {
                        attrs: {
                          "items-data": group.REPORTS,
                          "folder-type": "G",
                          groupId: group.FOLDER_ID
                        }
                      })
                    ],
                    1
                  )
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.courseReports.length || _vm.courseContent.FOLDER_CONTENT !== ""
        ? _c(
            "panel-basic",
            {
              attrs: {
                title:
                  "" +
                  _vm.$t("MAIN_CONTENT.classPage.index.classPage_courseInfo"),
                id: "course-info",
                collapsable: true
              }
            },
            [
              _c("template", { slot: "title" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.classPage.index.classPage_courseInfo"
                      )
                    ) +
                    "\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(_vm.courseContent.FOLDER_CONTENT)
                }
              }),
              _vm._v(" "),
              _c("class-items", {
                attrs: { "items-data": _vm.courseReports, "folder-type": "C" }
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.menu.length > 0
        ? _c(
            "panel-basic",
            {
              attrs: {
                title:
                  "" +
                  _vm.$t(
                    "MAIN_CONTENT.classPage.index.classPage_courseSections"
                  ),
                id: "course-sections",
                collapsable: true
              }
            },
            [
              _c("template", { slot: "title" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.classPage.index.classPage_courseSections"
                      )
                    ) +
                    "\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c(
                "nav",
                { attrs: { "aria-label": "Course Sections Navigation" } },
                [
                  _c("class-nav", {
                    attrs: {
                      size: "lg",
                      menu: _vm.menu,
                      course: _vm.course,
                      "current-section": _vm.section,
                      "show-home-section": false,
                      "course-content": _vm.courseContent
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.menu.length > 0
        ? _c("class-page-footer", {
            attrs: {
              "current-section": _vm.section,
              course: _vm.course,
              menu: _vm.menu,
              "course-content": _vm.courseContent
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }